import AuthComponent from './auth/auth.component';
import AuthWithConnectionComponent from './auth-with-connection/auth-with-connection.component';
import ConnectionsComponent from './connections/connections.component';
import ProfileComponent from './profile/profile.component';
import AuthService from './services/auth.service';
import IdleSessionService from './services/idle-session.service';
import AuthMenuComponent from './auth-menu/auth-menu.component';
import ProviderPickerComponent from './provider-picker/provider-picker.component';

const DEPENDENCIES = [
];

angular
  .module('ais.user', DEPENDENCIES)
  .run(['AuthService', async (AuthService) => {
    if (await AuthService.isExpiredSession()){
      AuthService.logout();
    }
  }])
  .run(['IdleSessionService', (IdleSessionService) => IdleSessionService.start()])
  .service('AuthService', AuthService)
  .service('IdleSessionService', IdleSessionService)
  .component('authMenu', AuthMenuComponent)
  .component('connections', ConnectionsComponent)
  .component('profile', ProfileComponent)
  .component('auth', AuthComponent)
  .component('authWithConnection', AuthWithConnectionComponent)
  .component('providerPicker', ProviderPickerComponent);
  